module.exports = __webpack_public_path__ + "Step 2.d4a5f37c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Step 2.png
// module id = hlN0
// module chunks = 0